import { render } from "./ConsumoTrimestral.vue?vue&type=template&id=20f63744"
import script from "./ConsumoTrimestral.vue?vue&type=script&lang=js"
export * from "./ConsumoTrimestral.vue?vue&type=script&lang=js"

import "./ConsumoTrimestral.vue?vue&type=style&index=0&id=20f63744&lang=css"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__